import { Facade } from "@/modules/budget/monitoring/input-forms/types/roots/Facade";
import { FilterSettingsForm } from "@/modules/budget/monitoring/input-forms/types/roots/FilterSettingsForm";
import { App12FilterSettingsForm } from "@/modules/budget/monitoring/input-forms/components/application12/app12_14InputForm";

export class App12InputFormFacade implements Facade {
    getFilterSettings(): FilterSettingsForm {
        const form: App12FilterSettingsForm = {
            user_id: "",
            edit_access: false,
            delete_access: false,
            convert: 1000,
            application: null,
            report_form_view: 1,
            child_status: null
        }
        return form
    }

}